import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AppState, ICart } from './cart';

const selectCart = createFeatureSelector<ICart>('cart');

/** True when the current client (from cart contact) is suspended (CR 196465). */
export const isClientSuspended = createSelector(
  selectCart,
  (cart: ICart): boolean => (cart?.contact?.client?.suspended === true)
);
